import useGetImagesPreviewConfig from './useGetImagesPreviewConfig'

export default useGetImagesPreviewConfig
